<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="d-sm-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-sm-0 me-auto">Layanan Darurat</h5>
              <form @submit.prevent="getDataList" class="d-flex gap-1">
                <div class="input-group">
                  <input
                    v-model="cariTitle"
                    type="text"
                    class="form-control bg-light"
                    placeholder="Pencarian..."
                    autocomplete="off"
                  >
                  <button class="btn btn-primary">Cari</button>
                </div>
              </form>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <div class="table-responsive">
              <table class="table align-middle table-striped table-hover">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th class="w-25 text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Nama Lengkap
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="w-75" scope="col">Keluhan</th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Tanggal
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Status
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-end" scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(p, i) in dataList.Records" :key="`ques-${i}`">
                    <th scope="row">{{ i+1 }}</th>
                    <td class="text-nowrap">{{p.user.user_profile.fullname}}</td>
                    <td>
                      <ul class="small nav flex-column">
                        <li
                          class="text-nowrap"
                          v-for="(item, index) in p.emergency_data"
                          :key="index"
                        >
                          <i class="ti ti-point-filled fs-1"></i>
                          {{item.question}}
                        </li>
                      </ul>
                    </td>
                    <td class="text-center text-nowrap">{{formatDate(p.createdAt)}}</td>
                    <td class="text-center text-nowrap">
                      <select
                        v-model="p.statusId"
                        @change="updateStatus(p.id, p.statusId)"
                        class="form-select form-select-sm bg-light text-center"
                        style="width: 110px;"
                      >
                        <option value="9">Open</option>
                        <option value="10">Close</option>
                        <option value="11">Direspon</option>
                      </select>
                    </td>
                    <td class="text-nowrap text-end">
                      <button
                        @click="openModalMessage(p.id)"
                        class="btn btn-sm btn-outline-warning"
                        title="Kirim Pesan"
                        data-bs-toggle="modal"
                        data-bs-target="#modalNewMessage"
                      >
                        <i class="ti ti-message fs-3"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <b-pagination
              class="justify-content-center"
              v-model="page"
              :total-rows="dataList.Count"
              :per-page="pageSize"
              prev-text="Previous"
              next-text="Next"
              @change="handlePageChange"
              size="md"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal New Message -->
    <form @submit.prevent="onSubmit">
      <div
        class="modal fade"
        id="modalNewMessage"
        tabindex="-1"
        aria-labelledby="modalNewMessageLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="modalNewMessagelLabel">Kirim Pesan</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <form>
                <div class="mb-4">
                  <label for class="form-label">Penerima / Responden</label>
                  <input
                    v-model="penerima"
                    type="text"
                    class="form-control"
                    value="Sahira Marwa Suryaningsih - 3578024512900001"
                    placeholder="Penerima / Responden..."
                    rows="3"
                    autocomplete="off"
                    disabled
                  >
                </div>
                <div class="mb-4">
                  <label for class="form-label">Subjek *</label>
                  <input
                    v-model="formPesan.subject"
                    class="form-control"
                    placeholder="Subjek..."
                    value="Pesan Baru"
                    autocomplete="off"
                    required
                  >
                </div>
                <div>
                  <label for class="form-label">Pesan *</label>
                  <textarea
                    v-model="formPesan.messages"
                    class="form-control"
                    placeholder="Isi Pesan..."
                    rows="3"
                    required
                  ></textarea>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-dark" data-bs-dismiss="modal">Batal</button>
              <button type="submit" class="btn btn-success">Kirim Pesan</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'

export default {
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			user_login: JSON.parse(localStorage.getItem('user_login')).data,
			token: localStorage.getItem('token'),
			cariTitle: '',
			order: 'desc',
			page: 1,
			pageSize: 30,
			pageSizes: [10, 20, 50],
			statusId: '',
			formPesan: {
				klasifikasi: 'Personal',
				responden: '',
				subject: '',
				messages: ''
			},
			penerima: ''
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		this.getDataList()
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
	},
	computed: {
		...mapGetters({
			dataList: 'location/getDataPayload',
			dataDetailList: 'location/getDataPayload2',
			countDataList: 'location/getCountDCLocation'
		}),
		userId: {
			// getter
			get() {
				return this.$route.query.userId || ''
			}
		}
	},
	methods: {
		getDataList(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getDataPayload', {
					url: `user_emergency`,
					params: {
						fullname: this.cariTitle,
						// userId: this.userId,
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
		},
		handlePageChange(value) {
			this.page = value
			this.getDataList()
		},
		handlePageSizeChange(event) {
			this.pageSize = parseInt(event.target.value)
			this.page = 1
			this.getDataList()
		},
		updateStatus(id, statusId) {
			console.log()
			this.$store
				.dispatch('location/createNewRecord', {
					data: {
						statusId: statusId
					},
					url: 'user_emergency/' + id,
					method: 'PUT'
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
					} else {
					}
				})
		},
		// detail(assessment_date, userId) {
		// 	let data = this.dataList.find((o) => o.assessment_date === assessment_date)
		// 	this.form = {
		// 		assessment_date: assessment_date,
		// 		fullname: data.fullname,
		// 		hpht: data.hpht,
		// 		hpl: data.hpl,
		// 		profile_kehamilan: data.profile_kehamilan,
		// 		type: data.type,
		// 		usia_kehamilan: data.usia_kehamilan,
		// 		tanggal_lahir: data.tanggal_lahir,
		// 		jenis_persalinan: data.jenis_persalinan
		// 	}

		// 	this.$store.dispatch('location/getDataPayload2', {
		// 		url: `user_assessment/` + userId,
		// 		params: {
		// 			assessment_date: assessment_date
		// 		}
		// 	})
		// 	this.penerima = data.fullname
		// 	this.formPesan.responden = userId
		// },
		slugify(text) {
			return text.toLowerCase().replace(/\s+/g, '-')
		},
		openModalMessage(id) {
			let data = this.dataList.Records.find((o) => o.id === id)
			this.penerima = data.user.user_profile.fullname
			// this.formPesan.responden = 7
			this.formPesan.responden = data.user.id
		},
		onSubmit() {
			const data = new URLSearchParams()
			data.append('klasifikasi', this.formPesan.klasifikasi)
			data.append('responden', this.formPesan.responden)
			data.append('subject', this.formPesan.subject)
			data.append('messages', this.formPesan.messages)

			this.$store
				.dispatch('location/createNewRecord', {
					data: data,
					url: 'messages/' + this.user_login.id,
					method: 'POST'
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
						document.querySelector('#modalNewMessage [data-bs-dismiss="modal"]').click()
						this.formPesan = {
							klasifikasi: 'Personal',
							responden: '',
							subject: '',
							messages: ''
						}
					} else {
					}
				})
		},
		formatDate(dateStr) {
			if (!dateStr) return '-' // biar aman kalau null/undefined/kosong
			const d = new Date(dateStr)
			const y = d.getUTCFullYear()
			const m = String(d.getUTCMonth() + 1).padStart(2, '0')
			const day = String(d.getUTCDate()).padStart(2, '0')
			const h = String(d.getUTCHours()).padStart(2, '0')
			const min = String(d.getUTCMinutes()).padStart(2, '0')
			return `${day}/${m}/${y} ${h}:${min} `
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
